/**
 * is multiple of 2
 *
 * @param number
 * @returns {boolean}
 */
const isEven = number => number % 2 === 0;
export default isEven;
